import Home from "./Page/Home";

function App() {
  return (
    <div className="overflow-hidden">
      <Home />
    </div>
  );
}

export default App;
